// extracted by mini-css-extract-plugin
export default {"card":"FeatureCard_card__JZwoP","avatar":"FeatureCard_avatar__I2cxN","button":"FeatureCard_button__RrzIk"};